export class User {
    constructor(id, username, name, email, bio = "", following = [], followers = []) {
        this.id = id;
        this.username = username;
        this.name = name;
        this.email = email;
        this.bio = bio;
        this.following = following;
        this.followers = followers;
    }
    followsUserWithId(id) {
        return this.following.includes(id);
    }
}
